import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import DepositRegisterTableHead from '../../components/molecules/DepositRegisterTableHead';
import DepositRegisterTableBody from '../../components/molecules/DepositRegisterTableBody';
import DepositRegisterEdit from './DepositRegisterEdit';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import { getShops, getShopDetail } from '../../actions/Shop';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: 375,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  textNote: {
    padding: 26
  },
  textRed: {
    color: 'red'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      shops: state.shops.shops,
      totalCount: state.shops.totalCount,
      offset: state.shops.offset
    }),
    dispatch => ({
      actions: bindActionCreators({ getShops, getShopDetail }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('shopId', 'setShopId', null),
  withState('bankSwitchable', 'setBankSwitchable', true),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState('depositManageStr', 'setDepositManageStr', '入金を自身で管理する'),
  withState('bankAccountId', 'setBankAccountId', ''),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('accountStatus', 'setAccountStatus', ''),
  withState('page', 'setPage', 0),
  withState('email', 'setEmail', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    progress,
    shops,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    openEditModal,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    rowsPerPage,
    handleChangeRowsPerPage,
    shopId,
    setShopId,
    bankSwitchable,
    setBankSwitchable,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    setBankAccountId,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    updatedAt,
    setUpdatedAt,
    accountStatus,
    setAccountStatus,
    email,
    setEmail,
    roles
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const detail = {
      shopId,
      bankSwitchable,
      depositManage,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      updatedAt,
      accountStatus,
      email
    };

    const getShop = async id => {
      await actions.getShopDetail(id).then(detailData => {
        checkSession(detailData);
        setBankSwitchable(detailData.payload.bankSwitchable);
        setDepositManage(detailData.payload.depositManage);
        setDepositManageStr(detailData.payload.depositManageStr);
        setEmail(detailData.payload.email);
        if (
          typeof detailData.payload.bankAccount !== 'undefined' &&
          detailData.payload.bankAccount !== null
        ) {
          setBankAccountId(detailData.payload.bankAccount.bankAccountId);
          setBankName(detailData.payload.bankAccount.bankName);
          setBankBranchName(detailData.payload.bankAccount.bankBranchName);
          setBankAccountType(detailData.payload.bankAccount.bankAccountType);
          setBankAccountTypeStr(
            detailData.payload.bankAccount.bankAccountTypeStr
          );
          setBankAccountNumber(
            detailData.payload.bankAccount.bankAccountNumber
          );
          setBankAccountHolder(
            detailData.payload.bankAccount.bankAccountHolder
          );
          setAccountStatus(detailData.payload.accountStatus);
        }
      });
    };
    const editOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getShop(params.shopId)
        .then(() => {
          setShopId(params.shopId);
          setUpdatedAt(params.updatedAt);
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <DepositRegisterTableHead />
            <DepositRegisterTableBody
              shops={shops}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              editOpenAction={editOpenAction}
            />
          </Table>
        </div>
        {/* {roles.isDeveloper && ( */}
        {roles.isShop && (
          <div className={classes.textNote}>
            {shops[0].email}
            <br />
            <div className={classes.textRed}>
              下記、Stripeで登録するメールアドレスは、こちらに表示されているごちめし登録のメールアドレスと同一のメールアドレスで、登録してください。
              <br />
              （ごちめしとStripeを紐付けるには2つのメールアドレスが一致している必要があります。）
            </div>
          </div>
        )}
        <div>
          <ExPagination
            searchResults={shops}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        {/* )} */}
        <Modal open={openEditModal}>
          <DepositRegisterEdit
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
